<!-- <div class="bg-white-dark p-4 flex gap-4">
  <span>Du befindest dich im Beta-Test-Bereich</span>
  <button (click)="goBack()">Zurück zur Hauptapp</button>
</div> -->

<div class="flex flex-col h-screen">
  <div
    class="flex-shrink-0 bg-background-dark px-4 py-3 flex flex-col lg:flex-row items-center justify-between gap-3 lg:gap-0 w-screen relative left-1/2 -translate-x-1/2 border-b dark:border-grey"
  >
    <div class="flex flex-col gap-1 order-2 lg:order-2">
      <span class="dark:text-white order-1 lg:order-2 text-center text-xs"
        >Du befindest dich im Beta-Test-Bereich. Bitte denke daran, dass deine Fortschritte für die Beta nur auf diesem Gerät/Browser gespeichert werden (in Arbeit). Nachdem du das Modul abgeschlossen hast, kannst du dein Feedback geben. Wir freuen uns, danke!</span
      >
      <span class="dark:text-white order-1 lg:order-2 text-center text-xs"
        >You're in the beta test area. Please keep in mind that, for now, your beta progress is only saved on this device/browser (work in progress). Once you've completed the module, you can share your feedback. We'd really appreciate it, thanks!</span
      >
  </div>

    <div class="order-2 lg:contents flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
      <button
        (click)="goBack()"
        class="order-1 blue-button hover:bg-primary-hover hover:text-white flex items-center justify-center gap-2 flex-1 lg:flex-none"
      >
        <i class="fa-regular fa-house text-base"></i>
    <div class="flex flex-col">
        <span class="font-bold text-xs">Zurück zur Hauptapp</span>
        <span class="font-bold text-xs">Back to main app</span>
        </div>
      </button>

      <a
        href="https://forms.cloud.microsoft/e/hXBEjTPF4L"
        target="_blank" rel="noopener noreferrer"
        class="order-3 blue-button hover:bg-primary-hover hover:text-white flex items-center justify-center gap-2 flex-1 lg:flex-none"
      >
        <i class="fa-regular fa-comment text-base"></i>
    <div class="flex flex-col">
        <span class="font-bold text-xs">Feedback geben</span>
        <span class="font-bold text-xs">send Feedback</span>
        </div>

    </a>
    </div>
  </div>

  <iframe
    src="https://beta.knoot-academy.de"
    class="flex-1 w-full border-0"
  ></iframe>
</div>

<!-- <div class="beta-test-container flex flex-col items-center justify-center w-full h-full">
  <iframe src="https://knoot-app-kursmodule-dev.rubina-d4b.workers.dev/kurse/ai-engineering" class="w-full h-full" frameborder="0"></iframe>
</div> -->